function Order() {
    return (
        <>
       <h1>Order online here</h1>
        </>
      );
    }

export default Order;